export default "__VITE_ASSET__DlXGQoon__"